// AUTO-GENERATED by scripts/prepare-brand.mjs — do not edit
export default function FAQSection() {
	return null
}
